export default [
  {
    path: '/whd_business',
    component: resolve => require(['./WhdBusiness.vue'], resolve),
    name: 'whd_business',
    leaf: true//只有一个节点
  }
]
